import { createContext, useContext } from 'react'

// True only inside an AI suggestion's widget — the read-only preview and the
// editable island. Both are LOCAL draft surfaces: their content is not in the
// note's document and does not exist for anyone else until the clinician
// accepts. They render the same real node views the note does, so a node view
// that writes FHIR on interaction would commit a clinical record from a
// suggestion the clinician has not accepted (and may reject).
//
// Node views and the hooks behind them read this to suppress that write while
// still rendering. The accept pipeline re-applies whatever the accepted content
// implies, keyed to the accept receipt, so a suppressed write is deferred
// rather than lost.
//
// Default false: the note editor keeps every node behavior intact.
export const RenderSafeContext = createContext<boolean>(false)

export function useIsRenderSafe(): boolean {
  return useContext(RenderSafeContext)
}
